import { render } from "./PortfolioDetailsPage.vue?vue&type=template&id=56a2a77c"
import script from "./PortfolioDetailsPage.vue?vue&type=script&lang=js"
export * from "./PortfolioDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__